import React, { useState, useEffect } from 'react';
import { getUserAttributes } from '../../utils';
import LoadingBackdrop from '../../components/LoadingBackdrop';
import Header from '../../components/misc/Header';
import Layout from '../../components/Account/EditName';

export default function EditName() {
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);

  async function getUser() {
    setLoading(true);
    try {
      const user = await getUserAttributes();
      const firstName = user['custom:first_name'];
      const lastName = user['custom:last_name'];
      setFirstName(firstName || '');
      setLastName(lastName || '');
    } catch {
      setFirstName('');
      setLastName('');
    }
    setLoading(false);
  }

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <LoadingBackdrop open={loading} />
      {firstName !== null && lastName !== null && (
        <React.Fragment>
          <Header header="Edit Name" />
          <Layout firstName={firstName} lastName={lastName} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
